import { render } from "./FlatpickrWrapper.vue?vue&type=template&id=3b4e5072&ts=true"
import script from "./FlatpickrWrapper.vue?vue&type=script&lang=ts"
export * from "./FlatpickrWrapper.vue?vue&type=script&lang=ts"

import "./FlatpickrWrapper.vue?vue&type=style&index=0&id=3b4e5072&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__